<template>
  <div class="review-card">
    <div class="nav-buttons">
      <div
        style="
          border-radius: 50%;
          background: rgba(192, 149, 89, 0.2);
          width: 48px;
          height: 48px;
          font-size: auto;
          display: grid;
          place-items: center;
          color: #c09559;
          position: absolute;
          top: calc(50% - 24px);
          left: 16px;
          cursor: pointer;
        "
        @click="$emit('goPrev')"
      >
        ‹
      </div>
      <button
        style="
          border-radius: 50%;
          background: rgba(192, 149, 89, 0.2);
          width: 48px;
          height: 48px;
          font-size: auto;
          display: grid;
          place-items: center;
          color: #c09559;
          position: absolute;
          top: calc(50% - 24px);
          right: 16px;
          cursor: pointer;
        "
        @click="$emit('goNext')"
      >
        ›
      </button>
    </div>
    <div class="review-card-icon">
      <img
        src="@/assets/img/iconsSvg/reviewIcon.svg"
        width="48px"
        height="48px"
        alt="icon"
      />
    </div>
    <p
      style="
        margin-top: 38px;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 10;
        -webkit-box-orient: vertical;
        word-break: break-word;
        white-space: normal;
        height: max-content;
      "
    >
      {{ review.text }}
    </p>
    <v-row no-gutters align="center" justify="center" style="margin-top: 38px">
      <div
        style="
          border-radius: 50%;
          background: #c09559;
          width: 48px;
          height: 48px;
          color: #f8f6f2;
          text-align: center;
          font-family: Inter;
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          line-height: 24px;
          display: grid;
          place-items: center;
          text-transform: uppercase;
          user-select: none;
        "
      >
        {{ review.client_name.substring(0, 2) }}
      </div>
      <v-col class="py-0" cols="auto" style="text-align: left !important">
        <p class="review-client_name" style="text-align: left">
          {{ review.client_name }}
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    review: {
      required: true,
    },
    goNext: Function,
    goPrev: Function,
  },
};
</script>

<style scoped>
.review-card {
  padding: 48px 58px;
  border-radius: 8px;
  border: 1px solid #e9e4d8;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 8px 10px -6px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(2px);
  color: #163626;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 39px;
  width: 100%;
  position: relative;
}
.review-card-icon {
  width: 80px;
  height: 80px;
  display: grid;
  place-items: center;
  margin: 0 auto;
  border-radius: 50%;
  background: rgba(192, 149, 89, 0.1);
}
.review-client_name {
  color: #c09559;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  margin-bottom: 0px;
  margin-left: 16px;
}
</style>